import React, { Suspense } from "react";
import { Row } from "reactstrap";
import { useLocation } from "react-router-dom";
import errorCodes from "./errorCodes";
import useGeneralStyles from "./styles";

interface ErrorPageProps {
  href?: string;
  title?: string;
  code?: string;
  description?: string;
  iconType?: string;
}

const ErrorPage: React.FC<ErrorPageProps> = (props) => {
  let errorCodesConfig: ErrorPageProps = { ...props };
  const generalStyles = useGeneralStyles();

  const location = useLocation();
  const code = location?.state?.code;
  if (!props?.title || props?.title === "") {
    if (code && errorCodes[code]) {
      errorCodesConfig = {
        ...errorCodes[location.state.code as keyof typeof errorCodes],
      };
    } else {
      errorCodesConfig = {
        ...errorCodes.default,
      };
    }
  }
  const { description, title } = errorCodesConfig;

  return (
    <div>
      <Suspense fallback={<div>Loading...</div>}>
        <Row>
          <div style={generalStyles.errorPageTitle}>{title}</div>
        </Row>
        <Row>
          <div style={generalStyles.description}>{description}</div>
        </Row>
      </Suspense>
    </div>
  );
};

export default ErrorPage;
